module.exports = __webpack_public_path__ + "img/store-company.b540cd9f.png";